module.exports = __webpack_public_path__ + "static/img/Light_Rain.d79cde34.png";